import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { WorkflowFormFieldInputActualAddress } from '@workflows/types';
import { FormControl } from '@angular/forms';
import { RequestFormActualAddressComponent } from '@features/requests';
import { NgClass } from '@angular/common';

@Component({
  selector: 'x-input-actual-address-field',
  imports: [RequestFormActualAddressComponent, NgClass],
  templateUrl: './input-actual-address.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputActualAddressComponent {
  field = input.required<WorkflowFormFieldInputActualAddress>();
  control = input.required<FormControl<string | null>>();
  canExecute = input<boolean>(true);
}
